import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { ActionResponse } from 'types/ActivationOrderTypes';

// POST /activation_order/{id}/actions/delete — new lifecycle action endpoint (NEW -> DELETED).
// Distinct from the legacy DELETE /activationOrder/{id} in `deleteActivationOrder.ts`.
export type deleteActivationOrderActionDataType = {
  id: string;
  successCallback?: (result: ActionResponse) => void;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  successCallback,
  errorCallback,
  resultKey = 'deleteActivationOrderActionData',
}: deleteActivationOrderActionDataType) =>
  requestAsync({
    url: endpoints.getAOActionDeleteUrl(id),
    transform: (response: ActionResponse) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getAOActionDeleteUrl(id)}`,
    body: {},
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
